(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-coupon-banner"] && !Shopify.designMode) return;
  try {
    (function () {
    function showCopied(btn, message) {
      var live = btn.querySelector('.product-coupon-banner__live');
      if (live) live.textContent = message;
      btn.classList.add('is-copied');
      clearTimeout(btn._couponCopyTimer);
      btn._couponCopyTimer = setTimeout(function () {
        btn.classList.remove('is-copied');
        if (live) live.textContent = '';
      }, 2500);
    }

    function bind(btn) {
      if (btn.dataset.couponCopyBound === 'true') return;
      btn.dataset.couponCopyBound = 'true';
      var successMsg = btn.getAttribute('data-copy-success') || '';

      btn.addEventListener('click', function () {
        var code = btn.getAttribute('data-copy-code');
        if (!code) return;

        function done(ok) {
          if (ok && successMsg) showCopied(btn, successMsg);
        }

        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(function () { done(true); }).catch(function () {
            fallbackCopy(code, function (ok) { done(ok); });
          });
        } else {
          fallbackCopy(code, function (ok) { done(ok); });
        }
      });
    }

    function fallbackCopy(text, cb) {
      try {
        var ta = document.createElement('textarea');
        ta.value = text;
        ta.setAttribute('readonly', '');
        ta.style.position = 'fixed';
        ta.style.left = '-9999px';
        document.body.appendChild(ta);
        ta.select();
        var ok = document.execCommand('copy');
        document.body.removeChild(ta);
        cb(!!ok);
      } catch (e) {
        cb(false);
      }
    }

    function init(root) {
      root.querySelectorAll('[data-product-coupon-copy]').forEach(bind);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(document); });
    } else {
      init(document);
    }

    document.addEventListener('shopify:section:load', function (ev) {
      if (ev && ev.target) init(ev.target);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["video"] && !Shopify.designMode) return;
  try {
    // Garantir que o preview de vídeo seja reproduzido automaticamente
  document.addEventListener('DOMContentLoaded', function() {
    const videoPreviewElements = document.querySelectorAll('[data-video-preview="true"]');
    
    videoPreviewElements.forEach(function(element) {
      // Para elementos de vídeo HTML5
      if (element.tagName === 'VIDEO') {
        element.muted = true;
        element.loop = true;
        element.playsInline = true;
        element.autoplay = true;
        
        // Tentar reproduzir o vídeo
        element.play().catch(function(error) {
          console.log('Autoplay foi bloqueado para o preview do vídeo:', error);
        });
        
        // Garantir que o vídeo continue rodando
        element.addEventListener('ended', function() {
          element.currentTime = 0;
          element.play();
        });
      }
      
      // Para iframes (YouTube/Vimeo)
      if (element.tagName === 'IFRAME') {
        // Adicionar um delay para garantir que o iframe carregue
        setTimeout(function() {
          // Tentar forçar o play via postMessage para YouTube
          if (element.src.includes('youtube.com')) {
            element.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
          }
        }, 1000);
      }
    });
    
    // Também tentar reproduzir quando o usuário interage com a página
    function enableVideoPreview() {
      videoPreviewElements.forEach(function(element) {
        if (element.tagName === 'VIDEO') {
          element.play().catch(function() {
            // Silenciar erro se o autoplay ainda não for permitido
          });
        }
      });
    }
    
    // Eventos para ativar o preview após interação do usuário
    document.addEventListener('click', enableVideoPreview, { once: true });
    document.addEventListener('touchstart', enableVideoPreview, { once: true });
  });
  } catch(e) { console.error(e); }
})();

})();
